import React from 'react';
import { useSetAtom } from 'jotai';
import useSignalR from '../../Services/signalR';

import {
  notifyEndCallAtom,
  notifyStartCallAtom,
  notifyIncomingCallAtom,
  notifyClosePopUpAtom,
  notifyUpdateCallAtom,
} from '../../Atoms/HubAtoms';

export default function CallHubProvider({ channel }) {
  const setNotifyStartCall = useSetAtom(notifyStartCallAtom);
  const setNotifyUpdateCall = useSetAtom(notifyUpdateCallAtom);
  const setNotifyEndCall = useSetAtom(notifyEndCallAtom);
  const setNotifyIncomingCall = useSetAtom(notifyIncomingCallAtom);
  const setNotifyClosePopUp = useSetAtom(notifyClosePopUpAtom);

  useSignalR(`${window.databeasy?.API_URL}hubs/callhub`, channel, [
    {
      eventName: 'NotifyStartCall',
      callback: (message) => {
        setNotifyStartCall(message);
      },
    },
    {
      eventName: 'NotifyUpdateCall',
      callback: (message) => {
        setNotifyUpdateCall(message);
      },
    },
    {
      eventName: 'NotifyEndCall',
      callback: (message) => {
        setNotifyEndCall(message);
      },
    },
    {
      eventName: 'NotifyIncomingCall',
      callback: (message) => {
        setNotifyIncomingCall(message);
      },
    },
    {
      eventName: 'NotifyClosePopUp',
      //answeredByUserId: null -> call ended; a user id -> that operator answered
      callback: (customerId, answeredByUserId) => {
        setNotifyClosePopUp({ customerId, answeredByUserId });
      },
    },
  ]);

  return <div />;
}
